module.exports = __webpack_public_path__ + "527eff645d8ead16666afb6931041279.otf";